import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { PieChart } from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../../../providers/AppProvider';
import ReactEchart from '../../../../../components/common/ReactEchart';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    PieChart,
    CanvasRenderer,
    LegendComponent
]);

//Obtiene las configuraciones de la grafica 
const getOptions = (data, getThemeColor) => {

    //obtiene la configuracion de colores 
    if (!getThemeColor || typeof getThemeColor !== 'function') {
        console.error("getThemeColor is not a function or is undefined");
        return {};
    }

    return {
        color: [
            getThemeColor('primary'),
            getThemeColor('info'),
            getThemeColor('warning'),
            getThemeColor('danger'),
            getThemeColor('success')
        ],
        tooltip: {
            trigger: 'item',
            padding: [7, 10],
            backgroundColor: getThemeColor('gray-100'),
            borderColor: getThemeColor('gray-300'),
            textStyle: { color: getThemeColor('gray-1100') },
            borderWidth: 1,
            transitionDuration: 0,
            formatter: function (params) {
                return `<strong>${params.data.name}:</strong> ${params.percent}%`;
            }
        },
        legend: { show: false },
        series: [
            {
                name: 'Dias',
                type: 'pie',
                radius: ['100%', '67%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderWidth: 2,
                    borderColor: getThemeColor('gray-100')
                },
                label: {
                    show: false,
                    formatter: '{b}: {d}%'
                },
                emphasis: {
                    scale: false
                },
                labelLine: { show: false },
                data: data.map(alert => ({ value: alert.amount, name: alert.title }))
            }
        ]
    };
};

const PieChartKm = ({ data }) => {
    const chartRef = useRef(null);
    const { getThemeColor } = useAppContext() || {};
    const totalEventos = data.reduce((sum, alert) => sum + parseInt(alert.target, 10), 0);

    return (
        <div className="position-relative py-2">
            <ReactEchart
                ref={chartRef}
                echarts={echarts}
                option={getOptions(data, getThemeColor)}
                style={{ height: '12.5rem' }}
            />
            <div className="position-absolute top-50 start-50 translate-middle text-center">
                <p className="fs-10 mb-0 text-400 font-sans-serif fw-medium">Total</p>
                <p className="fs-6 mb-0 font-sans-serif fw-medium mt-n2">{totalEventos}</p>
            </div>
        </div>
    );
};

PieChartKm.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
            target: PropTypes.number.isRequired
        })
    ).isRequired
};

export default PieChartKm;